import { useState } from 'react';
import { Stack, IconButton, Typography, Popover } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import CloseIcon from '@mui/icons-material/Close';
import { EventItemDisplay } from './EventItemDisplay';
import { EventTeeSheet } from './EventTeeSheet';
import { useTBContext } from '../Contexts/useTBStates';


interface TeeSheetPopoutProps {
   /*  event: any; */
    /* factor: number;
    appTheme: any;*/
    /* setEditEvent: (event: any) => void; */
    /*forceUpdate: boolean;
    optionsLoaded: any[];
    thisEventData: any;
    setThisEventData: React.Dispatch<React.SetStateAction<any>>;
    roundValue: number;
    editMode: boolean; */
    compHeights: any;
}


export const TeeSheetPopout = ({
   /*  event,  */
    /* factor, 
    appTheme, */
    /* setEditEvent,  */
    /*forceUpdate, 
    optionsLoaded, 
    thisEventData, 
    setThisEventData, 
    roundValue,
    editMode, */
    compHeights
}: TeeSheetPopoutProps) => {

    const {
        viewEvent,
        setViewEvent,
        roundValue,
        optionsLoaded,
        forceUpdate,
        factor, appTheme
      } = useTBContext();
    
    const [open, setOpen] = useState(false);

    return (
        <Stack direction={'row'} spacing={2} sx={{ display: 'flex', height: 60*factor, justifyContent: 'flex-start', padding: '0px 20px', alignItems: 'center' }}>
            <IconButton color='primary'
                sx = {{
                    width: '100%',
                    borderRadius: 2,
                    padding: 0.5,
                    justifyContent: 'flex-start',
                    border: '1px solid transparent',
                    '&:hover': {border: `1px solid ${appTheme.palette.primary.extraLight}`},
                    '&:active': {backgroundColor: 'transparent'},
                    '&:focus': {backgroundColor: 'transparent'},
                }}
            onClick={() => {
                setOpen(true);
            }}>
                <Typography variant='subtitle2' color='primary.main' sx={{ fontWeight: 500, display: 'flex', alignItems: 'center', textAlign: 'left', justifyItems: 'center' }}>
                    <LaunchIcon sx={{ fontSize: 16 }} />Tee Sheet
                </Typography>
            </IconButton>
            <Popover
                open={open}
                anchorEl={document.getElementById('tournament-builder-footer')}
                onClose={() => setOpen(false)}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                sx={{
                    backgroundColor: 'rgba(0, 0, 0, 0.3)',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}  
                PaperProps={{
                    sx: {
                        backgroundColor: 'white',
                        margin: 'auto 10%', // Center horizontally
                        width: '80vw', // Ensure it has a defined width,
                        height: '90vh',
                        padding: 2,
                    }
                }}
            >
                <Stack direction='column' spacing={2} sx={{
                    /* width: '100%', 
                    height: '100%',  */
                    flex: 1,
                    /* padding: 2, */
                    zIndex: 1000,
                   
                    
                }}>
                    <Stack direction={'row'} spacing={2} 
                        sx={{ flex: 1, height: 60*factor, justifyContent: 'flex-end', 
                            padding: '0px 20px', alignItems: 'center',
                            borderBottom: `1px dotted ${appTheme.palette.primary.light}`,
                        }}
                    >
                        <Stack direction='row' spacing={2} alignItems={'center'} flex={5} sx={{ minHeight: 60*factor}}>
                            <EventItemDisplay orient='column' label='Event Name' keyName='eventName' extraFactor={1.5}
                                hideLabel={true} flipped={true} locked={true} />

                            <Typography sx={{ fontSize: 24*factor }}>@</Typography>
                            <EventItemDisplay orient='column' label='Course' keyName='courseName' extraFactor={1.5}
                                hideLabel={true} locked={true} />
                                
                        </Stack>
                        <Typography flex={2} sx={{ fontSize: 12*factor*1.5 }}>Tee Sheet  |  Round {roundValue}</Typography>
                        <IconButton color='error'
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                    <Stack direction='row' spacing={2} flex={1} padding={'10px 30px'}>
                        <EventTeeSheet 
                            /* event={event} 
                            viewEventData={thisEventData} 
                            setViewEventData={setThisEventData}  */
                            /* roundValue={roundValue} */ 
                           /*  eventType={optionsLoaded.find(o => o.keyName === 'eventTypes')?.options?.find((o: any) => o.value === thisEventData.rounds[roundValue-1].eventTypeID)}*/
                            /* appTheme={appTheme} */
                            /* editMode={editMode} */ 
                            /* factor={factor*1.25} */
                            tabHeight={compHeights.appUsableHeight - 80*factor}
                            tabWidth={compHeights.appUsableWidth-120*factor}
                        />
                    </Stack>
                </Stack>
            </Popover>
        </Stack>
    )
}
